import React from 'react';

import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

export const RowCell: React.FC<{ children?: React.ReactNode; css?: SystemStyleObject; className?: string }> = ({
  children,
  css,
  className,
}) => (
  <Box
    className={className}
    css={{ display: 'flex', width: '100%', alignItems: 'center', paddingRight: 'space.300', ...css }}
    role="gridcell"
  >
    {children}
  </Box>
);
